"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_network__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "7ba04029-b5fc-444f-88be-cf0f312921de",
    "data-name": "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "9632a02a-cd12-447a-84ab-40246cb5020f",
    x1: 70.38,
    y1: 128.97,
    x2: 121.53,
    y2: 180.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "network-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "1b32526e-b9dd-4d21-a07f-e64af95a4811",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fe9c161c-4689-4abf-ba7a-5871e01d938e",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7aaff8f1-6fd0-4d89-b910-28c4dcd4762a",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "64e98a98-6c85-4a1e-8649-1cfa99573c4d",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ca28b64d-fcb1-4047-8a95-adf3cf9d7b15",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9488c063-55d1-4cc3-b6fe-def5c78cd9f2",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "519ba9fa-36d5-4706-bb1a-d9e042829ae2",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "46daf534-154a-4896-a62c-9d0c96382631",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8f7e7e86-eda5-4a81-bb06-2a2a2fd4e9bc",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "88d262a6-fed0-47f0-87e4-40a2bef19b67",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "110f5601-c440-4ccd-b66c-2421e2be442a",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "14fe5031-727f-44c1-bbc0-5cea21ca30ca",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "82889c1f-88aa-45ca-be85-b8e6644ef77b",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "92beca9e-a222-4cfd-b9fa-b9c888e39537",
    "data-name": "Call_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c2236c5f-d546-426b-be69-84f7012af276",
    "data-name": "Location_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a26af823-a561-4140-a5ac-2606bbdb1240",
    "data-name": "Mail_new_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "271e85b8-0073-4385-b0fd-52c87f9b90d1",
    "data-name": "Mail_unread_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e1a500ec-7200-4f67-a285-0637509e78b2",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9e4537fb-0778-4cc5-83c0-1012d4180137",
    "data-name": "Network_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bbfa1707-5bc8-4c2d-a722-c4ba0b6f2d3a",
    "data-name": "Network_signal_ic_mid"
  }, /*#__PURE__*/React.createElement("g", {
    id: "49e3e073-7ff9-44b5-bad0-0540911ccb91",
    "data-name": "Network_signal_ic_mid"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 67.82,
    y1: 172.01,
    x2: 111,
    y2: 124.01,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124,
    y1: 172.01,
    x2: 81,
    y2: 124.01,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("line", {
    x1: 67.82,
    y1: 172.01,
    x2: 111,
    y2: 124.01,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124,
    y1: 172.01,
    x2: 81,
    y2: 124.01,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127,169.34l-25.64-28.62,12.63-14a4,4,0,1,0-5.95-5.35L96,134.73,84,121.34a4,4,0,1,0-6,5.34l12.57,14L64.84,169.33a4,4,0,1,0,5.95,5.35L96,146.7l25.06,28a4,4,0,0,0,6-5.34Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#9632a02a-cd12-447a-84ab-40246cb5020f)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.08,133.73l-4.48,5L78,124.67a4,4,0,0,1-.88-1.7,4,4,0,0,0,.88,3.7l12.57,14,5.38-6Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.67,173a4,4,0,0,1-5.65-.31l-24.16-27-.9,1,25.06,28a4,4,0,0,0,6.84-3.64A4,4,0,0,1,126.67,173Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M114,124.68l-12.63,14-5.38,6-25.17,28A4,4,0,0,1,64,171a4,4,0,0,0,6.83,3.65L96,146.7l5.38-6,12.63-14a4,4,0,0,0,.89-3.7A4,4,0,0,1,114,124.68Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,176a4,4,0,0,1-3.86-3L96,81.62,71.68,173A4,4,0,0,1,64,171L92.13,65A4,4,0,0,1,96,62h0a4,4,0,0,1,3.86,3l28,106a4,4,0,0,1-3.87,5Z",
    transform: "translate(0 0)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,176a4,4,0,0,1-3.86-3L96,81.62,71.68,173A4,4,0,0,1,64,171L92.13,65A4,4,0,0,1,96,62h0a4,4,0,0,1,3.86,3l28,106a4,4,0,0,1-3.87,5Z",
    transform: "translate(0 0)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.87,171,100.66,68H91.33L64,171A4,4,0,0,0,71.68,173L96,81.62,120.13,173a4,4,0,1,0,7.73-2Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.87,65A4,4,0,0,0,96,62h0a4,4,0,0,0-3.87,3l-.8,3h9.33Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.86,171a4,4,0,0,1-7.73.06L96,79.62,71.68,171A4,4,0,0,1,64,171h0A4,4,0,0,0,71.68,173L96,81.62,120.13,173a4,4,0,1,0,7.73-2Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }))), /*#__PURE__*/React.createElement("path", {
    id: "d90a147c-6416-4654-ae22-207eabce3c96",
    "data-name": "<Pfad>",
    d: "M152.17,19.5a72.74,72.74,0,0,1,0,102.91",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "65955a09-71f1-4d99-b7cc-2dc93957b086",
    "data-name": "<Pfad>",
    d: "M136.6,34.39a52,52,0,0,1,0,73.53",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "158d2709-97aa-4382-834c-824a579fae81",
    "data-name": "<Pfad>",
    d: "M121.3,49.7a30.24,30.24,0,0,1,0,42.72",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "f7826cb2-87de-4942-bc78-d40f0f8b5447",
    "data-name": "<Pfad>",
    d: "M38.9,19.5a72.74,72.74,0,0,0,0,102.91",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "d3aaf896-b68d-4a5b-8ea1-2dd004190418",
    "data-name": "<Pfad>",
    d: "M54.48,34.39a52,52,0,0,0,0,73.53",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "852f9ebf-918a-496c-8386-8d03fe8586c1",
    "data-name": "<Pfad>",
    d: "M69.78,49.7a30.24,30.24,0,0,0,0,42.72",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.29
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.62,121.93a2.12,2.12,0,0,1-3.4-.52,2.14,2.14,0,0,0,3.4,2.52A74.68,74.68,0,0,0,175.5,70,74.65,74.65,0,0,1,153.62,121.93Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.86,70.16A53.94,53.94,0,0,1,138,107.44a2.12,2.12,0,0,1-3.4-.52,2.14,2.14,0,0,0,3.4,2.52A54,54,0,0,0,153.86,70.16Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.23,92.56a2.09,2.09,0,0,1-1.89-1.14,2.14,2.14,0,0,0,3.4,2.52,32.13,32.13,0,0,0,9.46-22.88c0-.33,0-.67,0-1a32.11,32.11,0,0,1-9.44,21.88A2.14,2.14,0,0,1,121.23,92.56Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9,122.55a2.14,2.14,0,0,1-1.52-.63A74.65,74.65,0,0,1,15.51,70a74.68,74.68,0,0,0,21.88,54,2.14,2.14,0,0,0,3.4-2.52,2.09,2.09,0,0,1-1.89,1.14Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.48,108.07a2.14,2.14,0,0,1-1.52-.63A53.94,53.94,0,0,1,37.15,70.16,54,54,0,0,0,53,109.44a2.14,2.14,0,0,0,3.4-2.52,2.09,2.09,0,0,1-1.89,1.14Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.78,92.56a2.14,2.14,0,0,1-1.52-.63,32.11,32.11,0,0,1-9.44-21.88c0,.33,0,.67,0,1a32.13,32.13,0,0,0,9.46,22.88,2.14,2.14,0,0,0,3.4-2.52,2.09,2.09,0,0,1-1.89,1.14Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 45.23,
    x2: 96,
    y2: 62.5,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })))))))))))))))))))), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }));
}

var _default = ic_network__dark;
exports.default = _default;